import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';

import { Input, TableLangValue } from '@/components/form';
import ResourceForm from '@/components/resources/form';
import View from '@/components/view';

const TagForm = ({ match }) => {
  return (
    <View>
      <ResourceForm resource="Tag" id={match.params.id} initialValues={{ name: '' }}>
        {({ submitting, renderActions, values }) => (
          <>
            <Card>
              <CardBody className={submitting ? 'loading' : ''}>
                <Row>
                  {values.name && (
                    <Col lg={6}>
                      <Input name="name" label="adminapp_name_deprecated" />
                    </Col>
                  )}
                  <Col lg={6}>
                    <Input name="alias" />
                  </Col>
                  <Col lg={12}>
                    <TableLangValue name="names" />
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <div className="mt-4 mb-4">{renderActions()}</div>
          </>
        )}
      </ResourceForm>
    </View>
  );
};

TagForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  }).isRequired
};

export default TagForm;
